import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { request } from "../core/api.client";

export interface IGoldRateDetails {
  RateDate: string;
  RateTime: string;
  Purity999: string;
  Purity916: string;
  [key: string]: string;
}

export interface IGoldRateChartApiResponse {
  data: IGoldRateDetails[];
}

export const getGoldRateChartData = async () => {
  try {
    const chartResponse = await request<IGoldRateDetails[]>({
      method: "POST",
      url: API_PATHS.goldRateList,
    });

    return chartResponse;
  } catch (err) {
    logErrorToNewRelic(err as Error);
  }
};
